/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Fonts_Font_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter Font Name" |
*
* @param {Options_Fonts_Font_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_fonts_font_name_placeholder = /** @type {((inputs?: Options_Fonts_Font_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Fonts_Font_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisir le nom de la police")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schriftart eingeben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci il nome del font")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите название шрифта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca el nombre de la fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输入字体名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォント名を入力")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ॉन्ट का नाम दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Digite o nome da fonte")
	return /** @type {LocalizedString} */ ("Enter Font Name")
});